import {Topbar} from './Topbar'
import {FC} from 'react'

type HeaderWrapperProps = {
  onToggleSidebar: () => void
}

export const HeaderWrapper: FC<HeaderWrapperProps> = ({onToggleSidebar}) => {
  return (
    <header
      id='kt_header'
      className='fixed top-0 left-[250px] right-0 h-[60px] z-30 bg-white border-b shadow-sm flex items-center'
    >
      <div className='w-full flex justify-between items-center px-4 lg:px-6'>
        {/* Sidebar Toggle (only visible on mobile) */}
        <div className='lg:hidden flex items-center p-2'>
          <button
            id='kt_aside_mobile_toggle'
            className='text-white bg-primary p-2 rounded-md'
            title='Toggle Menu'
            onClick={onToggleSidebar}
          >
            <svg className='w-6 h-6' viewBox='0 0 24 24' fill='none'>
              <path
                d='M4 6h16M4 12h16M4 18h16'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
        </div>

        {/* Left Section: Header, with margin from the sidebar */}
        <div className='text-2xl font-bold italic font-["Great_Vibes",cursive] text-primary my-5'></div>

        {/* Right Section: Topbar, with margin from right edge */}
        <div className='flex items-center mr-10'>
          <Topbar />
        </div>
      </div>
    </header>
  )
}
